import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { UserFunction, UserFunctionCheck, UserFunctionGuard, UserGroupType, UserService } from '@stylehaven/components';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UploadGuard extends UserFunctionGuard {
    protected FUNCTIONS_TO_CHECK: UserFunction[] = [UserFunction.submitMedia, UserFunction.publishMedia];
    protected USER_FUNCTION_CHECK: UserFunctionCheck = UserFunctionCheck.HasAny;

    constructor(
        protected userService: UserService,
        protected router: Router
    ) {
        super(userService, router);
    }

    override checkFunctions(userFunctionsToCheck: UserFunction[]): Observable<boolean> {
        const hasFunctions = super.checkFunctions(userFunctionsToCheck);
        const hasWritableGroups = this.checkWritableGroups();
        const hasZoneGroups = this.checkZoneGroups();

        return combineLatest([hasFunctions, hasWritableGroups, hasZoneGroups]).pipe(
            map(([hasWritableGroup, hasZoneGroups, hasFunctions]) => hasWritableGroup && hasZoneGroups && hasFunctions)
        );
    }

    /**
     * MED-5432: For Uploading a user should be member of non-Zone, writable group
     * @returns
     */
    private checkWritableGroups(): Observable<boolean> {
        return this.userService
            .getUserGroups()
            .pipe(map(groups => groups.some(group => group.WriteRights && group.Type !== UserGroupType.Zone)));
    }

    /**
     * MED-5888: For Uploading a user should be member of a Zone
     * @returns
     */
    private checkZoneGroups(): Observable<boolean> {
        return this.userService
            .getUserGroups()
            .pipe(map(groups => groups.some(group => group.Type === UserGroupType.Zone)));
    }
}
